export const INVOICE_TYPES = {
  PARTNER_CLIENT: 1,
  ANNA_PARTNER: 2,
  PARTNER_PARTNER: 3,
  CORRECTIVE_DOCUMENT: 4,
  PARTNER_ANNA: 5
};
